import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bd9add9e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9add9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd9add9e')) {
      api.createRecord('bd9add9e', component.options)
    } else {
      api.reload('bd9add9e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bd9add9e&scoped=true&", function () {
      api.rerender('bd9add9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PwV78xiYhIMP/JS/comp/SearchFilterTokens.vue"
export default component.exports